import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DateRange } from './timeDateRangeSelection.state';

export const getTimeDateRangeSelectionState = createFeatureSelector< DateRange>('timeDateRangeSelection');

export const getTimeDateRange = createSelector(
  getTimeDateRangeSelectionState,
  (state) => state.timeDateRangeSelection
);